import { FC } from 'react';
import { IRecording } from '../../appointments/recording/RecordingState';
import { BulletList } from '../view-note/ViewNoteSection';

export const AIDetailedSummary: FC<{ recording: IRecording; }> = ({ recording }) => {
    const recordingHasDetailedSummary = Object.keys(recording?.summary?.detailedSummary || {}).some(k => Boolean((recording.summary!.detailedSummary as any)[k].length));

    return recordingHasDetailedSummary && recording.summary && (
        <div>
            <BulletList heading="Key Topics Discussed" items={recording.summary.detailedSummary?.keyTopicsDiscussed} />
            <BulletList heading="Decisions Made" items={recording.summary.detailedSummary?.decisionsMade} />
            <BulletList heading="Instructions or Recommendations" items={recording.summary.detailedSummary?.instructionsOrRecommendations} />
            <BulletList heading="Next Steps" items={recording.summary.detailedSummary?.nextStepsAndFollowups} />
            <div style={{color: 'var(--ion-color-step-600)', fontSize: 14, marginTop: 18}}>AI can make mistakes. Double-check important info.</div>
        </div>
    );
};
